<template>
  <div class="header">
    <div class="topbg">
      <div class="top">       
        <HeaderBar
          v-if="!isEnglish"
          :width="pageWidth"
          :bgColor="bgColor"
          :registerTextColor='registerTextColor'
          :loginTextColor="loginTextColor"
        />
        <!-- <div class="travel-book">
          <Icon type="flag" color="red" size="16px"></Icon>
          <span>旅行社预约</span>
        </div> -->
        <div class="top-nav-left">您好，欢迎来到绍兴古城！</div>
      </div>
    </div>
    <!-- 导航 -->
    <div class="content">
      <div class="right">
        <div class="nav" v-if="!isEnglish">
          <div
            class="tab-item"
            v-for="(item, index) in tabList"
            :key="item.value + index"
            :class="{
              on: item.routeName === value,
              logo: !item.label
            }"
            @click="onTabClick(item)"
          >
            {{ item.label || '' }}
            <div v-if="!item.label" class="logo">
              <img src="../../../assets/images/shaoxing/logo.png">
            </div>
            <div
              v-if="item.routeName === value && ShowChild"
              class="child-keqi"
            >
              <span 
                v-for="(sitem, sIndex) in item.children"
                :key="sitem.value"
                :class="{on: childIndex === sIndex}"
                @click="onTabClick(sitem, sIndex)"
              >
                {{ sitem.label }}
              </span>
            </div>
          </div>
        </div>
      </div>        
    </div>
  </div>
</template>
<script>
import { apiGet } from "@/fetch/api";
import { mapState } from "vuex";
import HeaderBar from "./headerBar";

export default {
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: "home"
    },
    isEnglish:{
      type: Boolean,
      default: false
    },
    Selectlanguage:{
      type: String,
      default: "chinese"
    }
  },
  components: {
    HeaderBar,
  },
  data() {
    return {
      showLoginModel:false,
      pageWidth: 100,
      bgColor: '',
      registerTextColor: '#fff',
      loginTextColor: '#fff',
      ShowChild: false,
      childIndex: undefined,
    };
  },
  computed: {
    ...mapState(["login", "userInfo", "m_id",''])
  }, 
  methods: {
    // 导航
    onTabClick(data, sIndex) {
      if (data.linkUrl === this.value) {
        return;
      }
      if (data.routeName === 'keqiOnlineBook') {
        this.ShowChild = data.value === 'onlineBook';
      } else {
        this.ShowChild = false
      }
      if (sIndex >= 0) {
        this.childIndex = sIndex;
      }
      this.$emit("change", data);
    },
  }  
}
</script>
<style scoped lang="scss">
.header {
  width: 100%;
  position: relative;
  .topbg {
    width: 100%;
    height: 30px;
    background:#3483F7;
    background-image: url('../../../assets/images/shaoxing/top-bg.jpg');
    .top {
      width: 1200px;
      height: 30px;
      line-height: 30px;
      margin: 0 auto;
      color: #333;
      display: flex;
      flex-direction: row-reverse;
      position: relative;
      .header-top-bar {
        width: 100px; 
        height: auto;
      }  
      .login {
        cursor: pointer;
      } 
      .regsiter {
        cursor: pointer;
        color:#126c42 ;
        padding-left: 20px;
      }
      .top-nav {
        color: #696969;
        margin-right: 10px;
      }
      .top-nav-left {
        color: #fff;
        position: absolute;
        left: 0
      }
      .travel-book {
        span {
          color: #fff;
          font-size: 12px;
          display: inline-block;
          margin-left: 10px;
        }
      }
    }    
  }
  .content {
    width: 1200px;
    height: 80px;
    line-height: 80px;
    margin: 0 auto;
    padding: 0 100px;
    display: flex;
    position: relative;
    z-index: 4;
    .nav {
      display: flex;
      .tab-item {
        width: 120px;
        text-align: center;
        color: #333;
        font-size: 18px;
        cursor: pointer;
        .child-keqi {
          position: fixed;
          background:#515467;
          z-index: 5;
          width: 125px;
          padding: 10px 0;
          span {
            display: block;
            height: 36px;
            line-height: 36px;
            text-align: center;
            cursor: pointer;
            opacity: 0.5;
          }
          .on {
            opacity: 1;
          }
        }
      }
      .logo {
        width: 300px;
        height: 80px;
        line-height: 80px;
        vertical-align: middle;
        padding-top: 4px;
        img {
          margin: 0 auto;
          width: 49px;
          height: 65px;
          vertical-align: middle;
        }
      }
      .on {
        color: #fff;
        background: #2DB0FE;
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shaoxing/components/header.vue